import ArchiveConfirmModal from './ArchiveConfirmModal';

export default ArchiveConfirmModal;
